import { Injectable } from '@angular/core';
import {
  MatSnackBar
} from '@angular/material/snack-bar';
import { IProfile, IResponse } from '@interfaces/index';
import { LibNotificationComponent } from '@ui-components/notification';
import { HttpService } from '@ui-components/services';
import { Observable, Subject, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  protected _profile: IProfile | null = null
  
  public loading = true;
  public onScroll: Subject<number> = new Subject();

  constructor(
    private _http_service: HttpService,
    private _snack_bar: MatSnackBar
  ) { }

  getProfile(): Observable<IResponse<IProfile>> {
    if(this._profile) {
      return of({
        data: this._profile,
        code: 200
      })
    }

    return this._http_service.post<IProfile>('auth/profile', {}).pipe(
      map(
        (response: IResponse<IProfile>) => {
          this._profile = response.data;
          return response;
        }
      )
    )
  }


  notify(message: string, status: string) {
    this._snack_bar.openFromComponent(LibNotificationComponent, {
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      panelClass: 'lib-notification',
      data: {
        message,
        status
      },
      duration: 3000
    });
  }

}